import { REMOVE_FIRST_NOTIFICATION, ADD_NOTIFICATION } from './types';

export const addNotification = (message, variant) => dispatch => {
  dispatch({ type: ADD_NOTIFICATION, payload: { message, variant } });
};

export const removeFirstNotification = () => dispatch => {
  dispatch({ type: REMOVE_FIRST_NOTIFICATION });
};
